/** Option `value` must match PUT /player/v2 API enums (case-sensitive). */
export const PLAYER_ROLES = [
  { value: '', label: 'Select player role' },
  { value: 'BATSMAN', label: 'Batsman' },
  { value: 'BOWLER', label: 'Bowler' },
  { value: 'WICKET_KEEPER', label: 'Wicket-keeper' },
  { value: 'BAT_ALL_ROUNDER', label: 'Batting all-rounder' },
  { value: 'BOWLING_ALL_ROUNDER', label: 'Bowling all-rounder' },
  { value: 'UMPIRE', label: 'Umpire' },
] as const;

export const BATTING_STYLES = [
  { value: '', label: 'Select batting style' },
  { value: 'RIGHT_HANDED', label: 'Right-handed' },
  { value: 'LEFT_HANDED', label: 'Left-handed' },
] as const;

export const BOWLING_STYLES = [
  { value: '', label: 'Select bowling style' },
  { value: 'RIGHT_ARM_FAST', label: 'Right-arm fast' },
  { value: 'RIGHT_ARM_MEDIUM', label: 'Right-arm medium' },
  { value: 'RIGHT_ARM_SPIN', label: 'Right-arm spin' },
  { value: 'LEFT_ARM_FAST', label: 'Left-arm fast' },
  { value: 'LEFT_ARM_MEDIUM', label: 'Left-arm medium' },
  { value: 'LEFT_ARM_SPIN', label: 'Left-arm spin' },
  { value: 'RIGHT_ARM_OFF_BREAK', label: 'Right-arm off break' },
  { value: 'LEFT_ARM_FAST_MEDIUM', label: 'Left-arm fast medium' },
  { value: 'RIGHT_ARM_FAST_MEDIUM', label: 'Right-arm fast medium' },
  { value: 'LEFT_ARM_ORTHODOX', label: 'Left-arm orthodox' },
  { value: 'RIGHT_ARM_MEDIUM_FAST', label: 'Right-arm medium fast' },
  { value: 'RIGHT_ARM_OFF_SPIN', label: 'Right-arm off spin' },
  { value: 'RIGHT_ARM_LEG_SPIN', label: 'Right-arm leg spin' },
  { value: 'AMBIDEXTROUS_BOWLING', label: 'Ambidextrous' },
  { value: 'LEFT_ARM_CHINAMAN', label: 'Left-arm chinaman' },
  { value: 'RIGHT_ARM_CHINAMAN', label: 'Right-arm chinaman' },
  { value: 'LEFT_ARM_MEDIUM_FAST', label: 'Left-arm medium fast' },
  { value: 'SLOW_BOWLER', label: 'Slow bowler' },
] as const;
